<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row row-equal">
            <div class="flex md3">
              <va-button
                outline
                color="info"
                @click="exportEmails('all')"
              >Emails entreprises</va-button>
            </div>
            <div class="flex md4">
              <va-button
                outline
                color="info"
                @click="exportMailing()"
              >Emails entreprises et partenaires</va-button>
            </div>
          </div>
        </va-card>
      </div>
      <div class="flex md12">
        <va-card title="Représentativité">
          <div class="row row-equal">
            <div class="flex md2">
              <va-input
                label="Année représentativité"
                outline
                color="info"
                v-model="yearRep"
              ></va-input>
            </div>
            <div class="flex md2">
              <va-input
                label="Année réference"
                outline
                color="info"
                v-model="yearRef"
              ></va-input>
            </div>
            <div class="flex md3">
              <va-button
                outline
                color="info"
                @click="exportRepUpd(yearRep, yearRef)"
              >Export Représentativité</va-button>
            </div>
          </div>
        </va-card>
      </div>
      <div class="flex md12">
        <va-card title="Représentativité obsolete">
          <div class="row row-equal">
            <div class="flex md3">
              <va-button
                outline
                color="info"
                @click="exportRep(2019, 2019, 2019, 2018)"
              >Représentativité 2019</va-button>
            </div>
            <div class="flex md4">
              <va-button
                outline
                color="info"
                @click="exportRepDiff()"
              >Représentativité 2020-2021</va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { launchToast } from "../../services/utils";

export default {
  data() {
    return {
      yearRep: 2023,
      yearRef: 2022
    };
  },
  methods: {
    async exportRepDiff() {
      try {
        let response = await axios.get("api/exports/repDiff", {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "export.xlsx";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
      }
    },
    async exportRepUpd(year, yearRef) {
      try {
        let response = await axios.get("api/exports/representativite", {
          responseType: "blob",
          params: {
            year: year,
            yearRef: yearRef
          },
        });

        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "export.xlsx";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
      }
    },
    async exportRep(yearStart, yearEnd, year1, year2) {
      try {
        let response = await axios.get("api/exports/rep", {
          responseType: "blob",
          params: {
            yearStart: yearStart,
            yearEnd: yearEnd,
            year1: year1,
            year2: year2,
          },
        });

        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "export.xlsx";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
      }
    },
    async exportMailing() {
      try {
        let response = await axios.get("/api/exports/mailing", {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: "text/csv",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "export.csv";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l’export");
      }
    },
    async exportEmails(type) {
      if (type === "all") {
        try {
          let results = await axios.get("/api/exports/emails", {
            params: { type: type },
          });

          this.downloadItem(results.data, "export.xlsx");
        } catch (err) {
          console.log(err);
          this.launchEpicmaxToast("Erreur lors de l’export");
        }
      }
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style>
</style>
